(function () {
  'use strict';

  /* ----------------------------------------------------------------
     郵便番号検索
  ---------------------------------------------------------------- */
  /* 郵便番号→住所の共通ルックアップ */
  function contactZipLookup(zipVal, silent) {
    var zip = zipVal
      .replace(/[－\-ー−]/g, '')
      .replace(/[０-９]/g, function (s) { return String.fromCharCode(s.charCodeAt(0) - 0xFEE0); })
      .replace(/\D/g, '');
    if (zip.length !== 7) {
      if (!silent) alert('郵便番号を7桁で入力してください（ハイフン不要）');
      return;
    }
    fetch('https://zipcloud.ibsnet.co.jp/api/search?zipcode=' + zip)
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (!data.results) {
          if (!silent) alert('該当する住所が見つかりませんでした。');
          return;
        }
        var r = data.results[0];
        var prefSelect = document.getElementById('ContactPrefecture');
        if (prefSelect) {
          for (var i = 0; i < prefSelect.options.length; i++) {
            if (prefSelect.options[i].text === r.address1) {
              prefSelect.selectedIndex = i;
              break;
            }
          }
        }
        var cityInput = document.getElementById('ContactCity');
        if (cityInput) cityInput.value = r.address2 + r.address3;
      })
      .catch(function () {
        if (!silent) alert('郵便番号の検索中にエラーが発生しました。しばらくしてから再試行してください。');
      });
  }

  /* 検索ボタン押下 */
  var zipBtn = document.getElementById('ContactZipSearch');
  if (zipBtn) {
    zipBtn.addEventListener('click', function () {
      var zipEl = document.getElementById('ContactZip');
      contactZipLookup(zipEl ? zipEl.value : '', false);
    });
  }

  /* 郵便番号7桁入力で自動検索 */
  var zipAutoEl = document.getElementById('ContactZip');
  if (zipAutoEl) {
    zipAutoEl.addEventListener('input', function () {
      contactZipLookup(this.value, true);
    });
  }

  /* ----------------------------------------------------------------
     確認ステップ
  ---------------------------------------------------------------- */
  var form = document.getElementById('ContactForm');
  var formWrap = document.getElementById('ContactFormWrap');
  var confirmWrap = document.getElementById('ContactConfirm');
  var confirmList = document.getElementById('ContactConfirmList');
  var backBtn = document.getElementById('ContactConfirmBack');
  var sendBtn = document.getElementById('ContactConfirmSend');

  if (!form || !formWrap || !confirmWrap) return;

  /* 「確認ページへ」ボタンを押したとき → 確認パネルへ（form submit は発生させない） */
  var submitBtn = document.getElementById('ContactSubmitBtn');
  if (!submitBtn) return;

  submitBtn.addEventListener('click', function () {
    /* バリデーション */
    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    /* 確認リストを生成 */
    var rows = [
      { label: 'お名前', value: val('ContactLastName') + ' ' + val('ContactFirstName') },
      { label: 'お名前（カナ）', value: val('ContactLastNameKana') + ' ' + val('ContactFirstNameKana') },
      { label: '郵便番号', value: val('ContactZip') ? '〒' + val('ContactZip') : '' },
      { label: '都道府県', value: selVal('ContactPrefecture') },
      { label: '市区町村', value: val('ContactCity') },
      { label: '番地・ビル名', value: val('contact[address]', true) },
      { label: '電話番号', value: val('ContactPhone') },
      { label: 'メールアドレス', value: val('ContactEmail') },
      { label: 'お問い合わせ内容', value: val('ContactBody') }
    ];

    confirmList.innerHTML = '';
    rows.forEach(function (row) {
      if (!row.value || row.value.trim() === '') return;
      var dt = document.createElement('dt');
      dt.textContent = row.label;
      var dd = document.createElement('dd');
      dd.textContent = row.value;
      confirmList.appendChild(dt);
      confirmList.appendChild(dd);
    });

    /* 表示切り替え */
    formWrap.style.display = 'none';
    confirmWrap.style.display = 'block';
    confirmWrap.removeAttribute('aria-hidden');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });

  /* 「修正する」 → フォームへ戻る */
  backBtn && backBtn.addEventListener('click', function () {
    confirmWrap.style.display = 'none';
    confirmWrap.setAttribute('aria-hidden', 'true');
    formWrap.style.display = 'block';
  });

  /* 「送信する」 → 実際に送信 */
  sendBtn && sendBtn.addEventListener('click', function () {
    sendBtn.disabled = true;
    sendBtn.textContent = '送信中...';
    form.submit();
  });

  /* ---- ヘルパー ---- */
  function val(id, byName) {
    var el = byName ? form.querySelector('[name="' + id + '"]') : document.getElementById(id);
    return el ? (el.value || '') : '';
  }

  function selVal(id) {
    var el = document.getElementById(id);
    if (!el) return '';
    var opt = el.options[el.selectedIndex];
    return opt ? opt.text : '';
  }
})();
